import { z } from 'zod'
import { ERROR_MESSAGE, ERROR_MESSAGE_INVALID_NAME } from './error.type'
import { phoneInit, phoneSchema, PhoneType } from './phone.type'
import { hasNumbers, isValidName, validateField, validatePhones } from 'utils/validate.util'
import { emailFieldSchema } from 'utils/schema.util'

export type CreasAbrangencia = {
  id?: number | null
  bairro: string
  bairroId: string
  cidade: string
  cidadeId: string
}

export type CreasResponse = {
  id: number
  ativo: string
  nome: string
  diretor: string
  email: string
  endereco: AddressType
  telefones: PhoneType[]
  abrangencia: CreasAbrangencia[]
}

export const abrangenciaSchema = z.object({
  id: z.number().nullish(),
  bairroId: z.number().nullish(),
})

export type AbrangenciaType = z.infer<typeof abrangenciaSchema>

export const abrangenciaInit: AbrangenciaType = {}

const addressSchema = z.object({
  id: z.number().nullish(),
  bairro: z.preprocess((field) => {
    return validateField(field)
  }, z.string()),
  bairroId: z.coerce.string().refine((field) => !(!field || field === '' || field === '0'), {
    message: ERROR_MESSAGE,
  }),
  cep: z.string().min(1, ERROR_MESSAGE),
  cidade: z.preprocess((field) => {
    return validateField(field)
  }, z.string()),
  cidadeId: z.coerce.string().refine((field) => !(!field || field === '' || field === '0'), {
    message: ERROR_MESSAGE,
  }),
  complemento: z.preprocess((field) => {
    return validateField(field)
  }, z.string()),
  logradouro: z.string().min(1, ERROR_MESSAGE),
  numero: z.coerce.string().nullish(),
  uf: z.preprocess((field) => {
    return validateField(field)
  }, z.string()),
  ufId: z.coerce.string().refine((field) => !(!field || field === '' || field === '0'), {
    message: ERROR_MESSAGE,
  }),
  pontoReferencia: z.string().nullish(),
})

export const creasSchema = z.object({
  id: z.number().nullish(),
  ativo: z.string().nullish(),
  nome: z
    .string()
    .min(1, ERROR_MESSAGE)
    .refine((field) => !hasNumbers(field), {
      message: ERROR_MESSAGE_INVALID_NAME,
    }),
  diretor: z
    .string()
    .min(1, ERROR_MESSAGE)
    .refine((field) => !isValidName(field), {
      message: ERROR_MESSAGE_INVALID_NAME,
    }),
  email: emailFieldSchema,
  endereco: addressSchema,
  telefones: z.array(phoneSchema).transform((fields) => {
    return validatePhones(fields)
  }),
})

export type CreasType = z.infer<typeof creasSchema>

type AddressType = z.infer<typeof addressSchema>

const addressInit: AddressType = {
  id: null,
  bairro: '',
  bairroId: '0',
  cep: '',
  cidade: '',
  cidadeId: '0',
  complemento: '',
  logradouro: '',
  numero: '',
  uf: '',
  ufId: '0',
  pontoReferencia: '',
}

export const creasInit: CreasType = {
  endereco: addressInit,
  nome: '',
  diretor: '',
  email: '',
  telefones: [phoneInit],
}
